// ============================================================
// SemNucleo.js — a tela quando não há núcleo escolhido
//
// Existe por causa de um recuo que passou despercebido enquanto havia um
// núcleo só: várias telas faziam `userNucleo || "IFCE"`. Sem núcleo
// definido, elas carregavam o Ceará.
//
// Com um núcleo no sistema, isso era invisível e até conveniente. Com
// vários, é o pior resultado possível: para quem enxerga todos os núcleos,
// a tela mostra dado do Ceará sem dizer que é do Ceará, e quem lê acredita
// estar vendo o núcleo que escolheu. Para quem é de outro núcleo, vira
// erro de permissão sem explicação, porque as regras do Firestore recusam
// a leitura.
//
// Dizer "escolha um núcleo" é mais honesto do que escolher por ele.
// ============================================================

import { CINZA_ESC, TIPO, ESP } from "../tema";
import Card from "./Card";

export default function SemNucleo({ oQueFaria = "carregar esta tela" }) {
  return (
    <Card>
      <div style={{ ...TIPO.corpo, color: CINZA_ESC, lineHeight: 1.6, padding: ESP.sm }}>
        <b>Nenhum núcleo escolhido.</b>{" "}
        Use o seletor de núcleo no alto da página para {oQueFaria}.
      </div>
    </Card>
  );
}
